import BuildingPage from 'pages/BuildingPage';

const AdminWorkbook = (): JSX.Element => <BuildingPage />;

export default AdminWorkbook;
